module.exports = __webpack_public_path__ + "static/img/prices-header.837a87c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/prices-header.jpg
// module id = /uoI
// module chunks = 0